import { fetchWithAuth } from '../api';
import { HOSTED_APPLICATION_SIMULATION_STATUS_URL, POST_METHOD, STATUS_ACTIONS } from '../config';

type PassFundingStep = (companyToken: string, action: STATUS_ACTIONS, payload: Object) => Promise<void>;
type PassFundingStepRequest = {
  action: string;
};

export const passFundingStep: PassFundingStep = async (companyToken, action, args) => {
  const payload = { action, ...args };

  await fetchWithAuth<PassFundingStepRequest, null>(
    HOSTED_APPLICATION_SIMULATION_STATUS_URL,
    payload,
    companyToken,
    POST_METHOD,
  );
};
